import { NIL, v5 as uuidv5 } from 'uuid';

import type { DraftJob } from 'src/graphql/generated';

export const generateIdempotencyKey = (draft: DraftJob) =>
  uuidv5(
    JSON.stringify({
      applicationFormUrl: draft.applicationFormUrl,
      branding: draft.branding,
      categories: draft.categories,
      details: draft.details,
      expiresAt: draft.expiresAt,
      guidedDetails: draft.guidedDetails,
      hasAIAssistanceBeenUsed: draft.hasAIAssistanceBeenUsed,
      id: draft.id,
      isConfidential: draft.isConfidential,
      jobAdReference: draft.jobAdReference,
      jobWritingMode: draft.jobWritingMode,
      keySellingPoints: draft.keySellingPoints,
      locations: draft.locationsV2,
      phoneNumber: draft.phoneNumber,
      questionnaireId: draft.questionnaireId,
      salary: draft.salary,
      summary: draft.summary,
      titles: draft.titles,
      video: draft.video,
      workArrangements: draft.workArrangements,
      workTypes: draft.workTypes,
    }),
    NIL,
  );
